import {inject, Injectable} from '@angular/core';
import {CookieOptions, CookieService} from 'ngx-cookie-service';
import {environment} from '@epg-apps/cdh-environments';
import {ProfileService} from '@epg-apps/profile-api';

@Injectable()
export class AuthenticationService {
  private readonly cookieService: CookieService = inject(CookieService);
  private readonly profileService = inject(ProfileService);

  static readonly EP_TOKEN = 'EP_TOKEN';
  private readonly EP_ORIG_URL = 'EP_ORIG_URL';

  static mapCookieNameToEnvironment(cookieName: string): string {
    return environment.production
      ? cookieName
      : `${environment.version.toUpperCase()}_${cookieName}`;
  }

  login(redirectParams: string): void {
    this.resetStateAndRedirect(redirectParams);
    window.location.href = environment.authenticationUrl;
  }

  logout(redirectParams: string): void {
    this.resetStateAndRedirect(redirectParams);
    window.location.href = environment.logoutUrl;
  }

  private resetStateAndRedirect(redirectParams: string) {
    this.profileService.setUserProfile();
    this.setRedirectCookie(redirectParams);
  }

  private setRedirectCookie(redirectParams: string): void {
    const redirectUrl = environment.baseUrl + redirectParams;
    const oneHourFromNow: Date = new Date();
    oneHourFromNow.setTime(oneHourFromNow.getTime() + 3600_000);
    const cookieOptions: CookieOptions = {
      path: '/',
      domain: 'easypay-group.com',
      expires: oneHourFromNow,
    };
    this.cookieService.set(
      AuthenticationService.mapCookieNameToEnvironment(this.EP_ORIG_URL),
      redirectUrl,
      cookieOptions,
    );
  }
}
